<template>
    <b-overlay
      :show="mostrarLoader"
      opacity="0.50"
      rounded="sm"
      spinner-variant="primary"
      spinner-type="grow"
    >
        <b-card class="div-with-loading vs-con-loading__container">
            <b-row class="mt-2">
                <b-col lg="4" md="12" class="mb-1">
                    <b-form-group>
                        <label class="text-sm"><span class="text-danger">*</span> Nombre</label>
                        <b-input
                            label="Nombre"
                            v-model="formPlan.nombre"
                            class="w-full required"
                            v-validate="'required'"
                            name="nombre"
                            placeholder="Ingrese nombre del plan"
                            :class="[{'is-invalid': errors.has('nombre')}]"
                            maxlength="50"
                        />
                        <span class="text-danger text-sm" v-show="errors.has('nombre')">{{ errors.first('nombre') }}</span>
                    </b-form-group>
                </b-col>

                <b-col lg="4" md="12" class="mb-1">
                    <b-form-group>
                        <label class="text-sm"> Precio manual</label>
                        <b-input-group
                          prepend="$"
                        >
                            <b-form-input
                                label="Precio manual"
                                icon-pack="feather"
                                icon="icon-dollar-sign"
                                v-model="formPlan.precio_manual"
                                class="w-full"
                                name="precio_manual"
                                data-vv-as="precio manual"
                                placeholder="Ingrese precio final sin impuestos"
                                :class="[{'is-invalid': errors.has('precio_manual')}]"
                            />
                        </b-input-group>
                        <span class="text-danger text-sm" v-show="errors.has('precio_manual')">{{ errors.first('precio_manual') }}</span>
                    </b-form-group>
                </b-col>

                <b-col lg="4" md="12" class="mb-1">
                    <b-form-group>
                        <label class="text-sm"><span class="text-danger">*</span> Precio por trámite</label>
                        <b-input-group
                          prepend="$"
                        >
                            <b-input
                                label="Precio por trámite"
                                icon-pack="feather"
                                icon="icon-dollar-sign"
                                v-model="formPlan.precio_por_tramite"
                                class="w-full required"
                                v-validate="{ required: true }"
                                name="precio_por_tramite"
                                data-vv-as="precio por trámite"
                                placeholder="Ingrese precio por trámite"
                                :class="[{'is-invalid': errors.has('precio_por_tramite')}]"
                            />
                        </b-input-group>
                        <span class="text-danger text-sm" v-show="errors.has('precio_por_tramite')">{{ errors.first('precio_por_tramite') }}</span>
                    </b-form-group>
                </b-col>

                <b-col cols="12">
                    <el-form>
                        <el-form-item class="vx-col w-full">
                            <label><span class="text-danger">*</span> Tipo</label>
                            <el-select :options="plan_choice.tipo" v-model="formPlan.tipo">
                                <el-option
                                    v-for="item in plan_choice.tipo"
                                    :key="item.id"
                                    :label="item.text"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </b-col>
            </b-row>

            <b-form-checkbox
              v-model="formPlan.es_preferido"
              class="mb-2"
            >
              Es preferido
            </b-form-checkbox>

            <b-form-checkbox
              v-model="formPlan.mostrar_webapp"
              class=""
            >
              Mostrar en Webapp
            </b-form-checkbox>

            <el-form label-position="top" label-width="100px" class="mt-2">
                <hr>
                <h4 class="mt-2">Detalle</h4>
                <b-row style="width: 100%">
                    <b-col cols="10">
                        <el-form-item class="vx-col w-5/6">
                            <el-select :options="items_adicionales_options" v-model="nuevoAdicional">
                                <el-option
                                    v-for="item in items_adicionales_options"
                                    :key="item.token_publico"
                                    :label="'Item: '+item.nombre+' | Módulo: '+item.modulo+' | Límite: '+item.limite"
                                    :value="item.token_publico">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </b-col>

                    <b-col cols=2>
                        <el-form-item class="vx-col w-1/6 btn-guardar-adicional">
                            <el-button style="width: 100%" @click="agregarAdicional()" v-b-tooltip.top="'Agregar'"><font-awesome-icon icon="plus"/></el-button>
                        </el-form-item>
                    </b-col>
                </b-row>
            </el-form>


            <b-table-simple responsive ref="table" v-if="productsAdicionales.length > 0" class="mb-1">
                <b-thead>
                    <b-tr>
                        <b-th>Acciones</b-th>
                        <b-th sort-key="name">Nombre</b-th>
                        <b-th sort-key="category">Módulo</b-th>
                        <b-th sort-key="limit">Límite</b-th>
                        <b-th sort-key="price">Precio</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr :key="indextr" v-for="(tr, indextr) in productsAdicionales">
                        <b-td class="whitespace-no-wrap">
                            <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2 text-danger" @click.stop="deleteAdicional(tr.index)" />
                        </b-td>

                        <b-td>
                            <p class="product-name font-medium truncate">{{ tr.name }}</p>
                        </b-td>

                        <b-td>
                            <p class="product-category">{{ tr.category | title }}</p>
                        </b-td>

                        <b-td>
                            <p class="product-limit">{{ tr.limite }}</p>
                        </b-td>

                        <b-td>
                            <p class="product-price">${{ tr.price }}</p>
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>

            <p v-else class="text-center mb-1">No existen registros para mostrar.</p>

            <div class="mt-2" style="width: fit-content; margin: auto;border: 1px solid lightgray; border-radius: 0 0 5px 5px; border-color: lightgray;">
                <div style="display:flex;">
                    <div style="padding: 10px; min-width: 150px;">Subtotal:</div>
                    <div style="text-align: right; border-left: 1px solid; padding: 10px; min-width: 100px; border-color: lightgray; ">$ {{subtotal}}</div>
                </div>
                <div style="border-top: 1px solid; border-color: lightgray; display:flex;">
                    <div style="padding: 10px; min-width: 150px;">IVA:</div>
                    <div style="text-align: right; border-left: 1px solid; padding: 10px; min-width: 100px; border-color: lightgray; ">$ {{iva}}</div>
                </div>
                <div style="border-top: 1px solid; border-color: lightgray; display:flex;">
                    <div style="padding: 10px; min-width: 150px;">Total:</div>
                    <div style="text-align: right; border-left: 1px solid; padding: 10px; min-width: 100px; border-color: lightgray; ">$ {{total}}</div>
                </div>
            </div><br>
            <div class="text-center">
                <b-button id="button-with-loading" variant="primary" class="mt-2 vs-con-loading__container" @click="submitFormPlan">Guardar</b-button>
            </div>

        </b-card>
    </b-overlay>
</template>
<script>
import axios from '@/axios';

import { Validator } from 'vee-validate';
import es from 'vee-validate/dist/locale/es'
import ToastificationContent from "@core/components/toastification/ToastificationContent";

Validator.localize("es", es);

let TIPO_GRATUITO = 'GRA'
export default {
    data(){
        return{
            formPlan: {
                nombre:'',
                precio_manual: '',
                precio_calculado: '',
                precio_por_tramite:'',
                tipo:'BAS',
                es_preferido: false,
                mostrar_webapp: false,
            },
            itemsPerPage: 100,
            products: [],
            productsAdicionales:[],
            usuarios_options:[],
            planes_options:[],
            tipo_contrato_options:[],
            items_adicionales_options:[],
            nuevoAdicional:null,
            planBaseActual: null,

            plan_choice:{
                tipo:[
                    {id: 1, text: 'Base', value:'BAS'},
                    {id: 2, text: 'Personalizado', value:'PER'}
                ],
            },

            subtotal_plan: 0,
            iva_plan: 0,
            total_plan: 0,

            mostrarLoader: false,
        }
    },
    mounted(){
        this.openLoadingInDiv()
        axios.get('api/plan/inicializar-registro-plan/').then(response =>{
                this.items_adicionales_options = response.data.items
            }
        )
        this.isMounted = true
        this.closeLoadingInDiv()
        if(this.estaEnModoEdicion){
            this.cargarPlan();
        }
    },
    created () {
        if (!moduleDataList.isRegistered) {
        this.$store.registerModule('dataList', moduleDataList)
        moduleDataList.isRegistered = true
        }
        // console.log(moduleDataList)
        this.$store.dispatch('dataList/fetchDataListItems')
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            if(from.name=="RegistrarPlan"){
                vm.showToast();
            };
        });
      },
    computed:{
        subtotal: function(){
            var valor = 0.00;
            for(var i=0; i<this.productsAdicionales.length; i++){
                valor += Number(this.productsAdicionales[i].price)
            }

            this.subtotal_plan = valor
            this.formPlan.precio_calculado = (valor).toFixed(2)

            return (this.productsAdicionales.length>0 ? (valor).toFixed(2) : 0)
        },
        iva: function(){
            var valor = 0.00;
            for(var i=0; i<this.productsAdicionales.length; i++){
                valor += Number(this.productsAdicionales[i].price)
            }

            this.iva_plan = valor * 0.15
            return (this.productsAdicionales.length>0 ? (valor*0.15).toFixed(2) : 0)
        },
        total: function(){
            var valor = 0.00;
            for(var i=0; i<this.productsAdicionales.length; i++){
                valor += Number(this.productsAdicionales[i].price)
            }

            this.total_plan = (valor*1.15).toFixed(2)
            return (this.productsAdicionales.length>0 ? (valor*1.15).toFixed(2)  : 0)
        },

        estaEnModoEdicion(){
            if (this.$route.params.token_publico){
              return true
            }
            else{
              return false
            }
        }
    },
    methods:{
        submitFormPlan: function(){
            this.openLoadingInDiv();
            this.$validator.validateAll().then(result => {
                if (result) {
                    // if form have no errors
                    if (this.estaEnModoEdicion){
                        this.updatePlan()
                    }
                    else{
                        this.createPlan()
                    }
                } else {
                    this.closeLoadingInDiv();
                }
            });
        },

        agregarAdicional(){
            if(this.nuevoAdicional){
                for(var i=0;i<this.items_adicionales_options.length;i++){
                    if(this.items_adicionales_options[i].token_publico==this.nuevoAdicional){
                        this.productsAdicionales.push({token_publico:this.items_adicionales_options[i].token_publico, name:this.items_adicionales_options[i].nombre, category: this.items_adicionales_options[i].modulo, limite:this.items_adicionales_options[i].limite, price:this.items_adicionales_options[i].precio, index:this.productsAdicionales.length, modulo_cod:this.items_adicionales_options[i].modulo_cod})
                    }
                }
                this.nuevoAdicional = null
            }
        },
        deleteAdicional(index){
            this.productsAdicionales.splice(index, 1);
        },

        createPlan(){
            this.openLoadingInDiv()
            this.$validator.validateAll().then(result => {
                if (result) {
                    axios.post('api/plan/registrar-plan/', {plan:this.formPlan, detalle: this.productsAdicionales}).then(response =>{
                        this.$router.push('/administrador/planes/registrar/' + response.data.data.token_publico)
                        this.closeLoadingInDiv()
                    })
                }else{
                    this.closeLoadingInDiv()
                }
            })
        },

        updatePlan(){
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.openLoadingContained()
                    axios.post('api/plan/editar-plan/', {plan:this.formPlan, detalle: this.productsAdicionales}).then(response =>{
                        this.closeLoadingContained()
                        this.mostrar()
                    })
                }else{
                    // console.log(result)
                }
            })
        },

        openLoadingInDiv(){
            this.mostrarLoader = true
        },
        closeLoadingInDiv(){
            this.mostrarLoader = false
        },

        showToast() {
          this.$toast.success({
            component: ToastificationContent,
            props: {
              title: 'Plan',
              icon: 'SaveIcon',
              text: 'Cambios Guardados correctamente',
            },
          },
          {
            position: 'bottom-right',
          })
        },

        cargarPlan(){
            this.openLoadingInDiv()
            axios.get('api/plan/' + this.$route.params.token_publico)
                .then( response => {
                    this.formPlan = response.data
                    for (var i = 0; i < response.data.items.length; i++) {
                        this.nuevoAdicional = response.data.items[i].item.token_publico
                        this.agregarAdicional()
                    }
                    this.closeLoadingInDiv()
                })
        },
    }
}
</script>

<style>
    .el-input-number, .el-select{
        width: 100%
    }

    .btn-guardar-adicional .el-form-item__label{
        color: transparent !important;
    }

    .required > .vs-input--label::before{
        content: "* ";
        color: #F56C6C;
    }
</style>
